export default "/_next/static/chunks/fonts/FontAwesome5_Brands-5818bbd07dfd7095920a592049f5d9bd.ttf";